// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kl-c";
export var backButton = "_kl-4";
export var backIcon = "_kl-5";
export var chevronShortcut = "_kl-6";
export var container = "_kl-1";
export var editor = "_kl-8";
export var editorWrapper = "_kl-7";
export var prefix = "_kl-2";
export var searchIcon = "_kl-3";
export var suffix = "_kl-9";
export var suffixContent = "_kl-a";
export var suffixText = "_kl-b";
export var wrapper = "_kl-0";